<template>
    <div style="padding:10px;width:100%;margin:0 auto;min-height:100%;max-width:800px;">
        <loading :show="isLoading"></loading>
        <modal-x :show="showAlerts" @onclose="showAlerts = false">
            <div style="min-height: 200px;">
                <div style="text-align: center;">
                    <span class="glyphicon glyphicon-exclamation-sign" style="font-size: 3em;color: red;"></span>
                </div>
                <div style="text-align: center;">
                    <span style="font-size: 1.5em;">{{ lang.postEditor.updateFail }}</span>
                    <div v-for="err in errMsgs"
                        style="display: flex;justify-content: center;align-items: center;max-width: 400px;margin:0 auto;">
                        <div style="flex:1;" class="form-control">{{ lang.postEditor['updateFail_' + err.code] }} {{
                            err.code === '8006' ? '(' + err.value + ')' : '' }} </div>
                        <div style="width: 100px;">
                            <button style="width: 100%;" v-if="['8000', '8003'].includes(err.code)"
                                class="btn btn-default" @click="() => { inView = 'postbase'; showAlerts = false; }">
                                <span class="glyphicon glyphicon-chevron-right"></span> </button>
                            <button style="width: 100%;" v-if="['8004'].includes(err.code)" class="btn btn-default"
                                @click="() => { inView = 'prices'; showAlerts = false; }"> <span
                                    class="glyphicon glyphicon-chevron-right"></span> </button>
                            <button style="width: 100%;" v-if="['8005', '8006', '8007'].includes(err.code)"
                                class="btn btn-default" @click="() => { showTagsLabels(); showAlerts = false; }"><span
                                    class="glyphicon glyphicon-chevron-right"></span> </button>
                            <button style="width: 100%;" v-if="['8002'].includes(err.code)" class="btn btn-default"
                                @click="() => { inView = 'images'; showAlerts = false; }"> <span
                                    class="glyphicon glyphicon-chevron-right"></span> </button>
                            <button style="width: 100%;" v-if="['8008', '8009'].includes(err.code)"
                                class="btn btn-default"
                                @click="() => { inView = 'categoryLabels'; showAlerts = false; }"> <span
                                    class="glyphicon glyphicon-chevron-right"></span> </button>

                        </div>
                    </div>
                </div>
            </div>
        </modal-x>
        <modal-x :show="isSelectingImage" @onclose="isSelectingImage = false" :content-style="{ maxWidth: '800px' }">
            <image-list v-if="isSelectingImage" :user-id="postbase.userId" @onselect="onImgSelect"
                :processing="isProcessingImage"></image-list>
        </modal-x>
        <modal-x :show="isEditingPost" @onclose="isEditingPost = false">
            <post-editor v-if="isEditingPost" :user-id="userId" :edit-post-id="editingPostId"></post-editor>
        </modal-x>
        <modal-x :show="showCategory" @onclose="showCategory = false"
            :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
            <div v-if="cpdCatEditable"><span class="glyphicon glyphicon-pencil btn btn-default"
                    @click="showCategoryButtons = !showCategoryButtons">Categories</span></div>
            <category v-if="showCategory" :user-id="userId" :cat-node="catNode" :show-create-node="showCreateCatNode"
                @catSelected="onCatChange" :viewMode="{}" :showCheckbox="false" cat-type="listing" :expandAll="true"
                :showButtons="showCategoryButtons" @onChanges="onCategoryChanges">
            </category>
        </modal-x>
        <div>
            <div style="display: inline-block;float:left;">
                <img :src="cpdThumb" class="img-responsive" style="max-height:50px;float:right;" />
            </div>
            <div v-if="isRootPost" style="margin-bottom: 10px;text-align: right;">
                <div class="btn btn-default" @click="$router.push({ path: 'ShopInfo', query: { shopUserId: userId } })">
                    <span class="glyphicon glyphicon-home"></span>
                    {{ lang.common.shopInfo }}
                </div>
                <div class="btn btn-default" @click="$router.push({ path: 'PostList', query: { shopUserId: userId } })">
                    <span class="glyphicon glyphicon-list-alt"></span>
                    {{ lang.postEditor.posts }}
                </div>
                <div class="btn btn-default"><span @click="$router.go(-1)"> {{ lang.common.back }} </span></div>
            </div>
            <hr />
            <div style="padding:8px 0px;">
                <!-- Nav tabs -->
                <ul class="nav nav-tabs">
                    <li role="presentation" style="cursor:pointer;" @click="changeView('postbase')"
                        :class="{ active: inView === 'postbase' }"><a @click.prevent>{{ lang.postEditor.postbase }}</a>
                    </li>
                    <li role="presentation" style="cursor:pointer;" @click="changeView('images')"
                        :class="{ active: inView === 'images' }"><a @click.prevent>{{ lang.postEditor.imageAndContent
                            }}</a></li>
                    <li v-if="isRootPost" role="presentation" style="cursor:pointer;" @click="changeView('prices')"
                        :class="{ active: inView === 'prices' }"><a @click.prevent>{{ lang.postEditor.prices }}</a></li>
                    <li v-if="cpdIsRoot" role="presentation" style="cursor:pointer;" @click="showTagsLabels"
                        :class="{ active: inView === 'tagsLabels' }"><a @click.prevent>{{ lang.postEditor.tags }}</a>
                    </li>
                    <li v-if="isRootPost" role="presentation" style="cursor:pointer;"
                        @click="changeView('categoryLabels')" :class="{ active: inView === 'categoryLabels' }"><a
                            @click.prevent>{{
                                lang.postEditor.categoryLabels }}</a></li>
                    <li v-if="cpdIsRoot" role="presentation" style="cursor:pointer;" @click="changeView('links')"
                        :class="{ active: inView === 'links' }"><a @click.prevent> {{lang.postEditor.more }}</a>
                    </li>
                </ul>
            </div>

            <!-- Tab panes -->
            <div class="tab-content">
                <div class="tab-pane active">
                    <div class="row">
                        <div class="col-xs-12">
                            <div style="padding:6px;">
                                <div v-if="inView === 'postbase'">
                                    <div class="row" style="text-align:left;">
                                        <div class="col-xs-12 agx-col-head">
                                            <div>
                                                <span class="label label-default" style="font-size: 1em;">{{
                                                    lang.postEditor.title }}:</span>
                                                <span style="float: right;" v-if="cpdIsRoot" @click="showMainCatsClick"
                                                    class="btn btn-default">{{ catBtnLabel }}</span>
                                            </div>
                                            <div style="display:inline-block;" v-if="isRootPost === false">
                                                ( {{ lang.postEditor.seq }}: <input type="text"
                                                    @keydown="changePostbase('seq', $event.target.value)"
                                                    v-model="cpdPostbase.seq" style="width:50px;" /> )
                                            </div>
                                        </div>
                                        <div class="col-xs-12 agx-col-msg">
                                            <input class="form-control" style="width:100%;" type="text"
                                                v-model="cpdPostbase.title"
                                                @keydown="changePostbase('title', $event.target.value)">
                                        </div>

                                        <div class="col-xs-12 agx-col-head" style="padding-top: 10px;">
                                            <span class="label label-default" style="font-size: 1em;">{{
                                                lang.postEditor.content }}:</span>
                                        </div>
                                        <div class="col-xs-12 agx-col-msg">
                                            <textarea class="form-control" style="width:100%;height:200px;"
                                                v-model="cpdPostbase.textMsg"
                                                @keydown="changePostbase('textMsg', $event.target.value)"></textarea>
                                        </div>

                                        <div v-if="cpdIsRoot && cpdIsManagers">
                                            <div class="col-xs-12 agx-col-head">ExtRef:</div>
                                            <div class="col-xs-12 agx-col-msg">
                                                <textarea class="form-control" style="width:100%;height:50px;"
                                                    v-model="cpdPostbase.extRef"
                                                    @keydown="changePostbase('extRef', $event.target.value)"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-xs-12"
                                            style="text-align:center;margin-bottom: 4px;margin-top: 20px;">
                                            <div>
                                                <button class="btn btn-default" type="button"
                                                    style="width: 60%;font-size: 1.5em;"
                                                    @click="changePostbase('stateCode', 1 - cpdPostbase.stateCode)">
                                                    {{ lang.postEditor.public }}
                                                    <span v-if="cpdPostbase.stateCode !== 0"
                                                        class="glyphicon glyphicon-unchecked"></span>
                                                    <span v-if="cpdPostbase.stateCode === 0" style="color: green;"
                                                        class="glyphicon glyphicon-check"></span>
                                                </button>
                                                <button class="btn btn-default" type="button" style="font-size: 1.5em;"
                                                    v-if="postbase.stateCode === 0" @click="onShare">
                                                    {{ lang.common.share }}
                                                </button>
                                            </div>
                                        </div>

                                        <div class="col-xs-12" style="text-align:center;font-size: 2em;">
                                            <template v-if="cpdEditing.postbase">
                                                <input type="button" :value="lang.postEditor.cancelEdit"
                                                    class="btn btn-warning" @click="cancelPostbaseEdit"
                                                    style="width: 100px;" />
                                                |
                                            </template>
                                            <input type="button" :value="lang.postEditor.update" class="btn btn-primary"
                                                @click="updatePostClick" style="width: 100px;" />
                                            <div>
                                                {{ postbase.zoneEditDatetime }}
                                            </div>
                                        </div>



                                    </div>
                                </div><!--end of postbase tab-->

                                <div v-if="inView === 'images'"
                                    style="width:100%;margin:0 auto;overflow-y:scroll;overflow-x:hidden;">
                                    <div style="width:100%;position:relative;z-index:1;">
                                        <agx-medialist :files="images" v-on:removeclicked="onImageRemove"
                                            v-on:updateclicked="onImageUpdate"></agx-medialist>
                                    </div>
                                    <span class="form-control"
                                        style="text-align: center;cursor: pointer;height: 60px;display: flex;align-items: center;justify-content: center;color:blue;font-weight: bolder;"
                                        @click="showImgSelector(onPostImgSelect)">
                                        ++ {{ lang.postEditor.selectFile }} ++
                                    </span>
                                    <div v-on:dragover.prevent v-on:drop="onFileDrop" contenteditable="true"
                                        v-on:paste="onPaste"
                                        style="width:100%;border:1px dashed gray;height: 100px;display: flex;justify-content: center;align-items: center;font-weight: bolder;">
                                        <span style="color:gray;">--{{ lang.postEditor.dropFile }}--</span>
                                    </div>
                                </div>

                                <div v-if="inView === 'prices'" style="margin:0 auto;">
                                    <post-price v-if="inView === 'prices' && apiClient !== null" :apiClient="apiClient"
                                        :postId="editPostId"></post-price>
                                </div>

                                <div v-if="inView === 'tagsLabels'">
                                    <div>
                                        <!-- <h3 class="label-warning">{{ lang.postEditor.tags }}</h3> -->
                                        <div v-if="cpdCatEditable"><span
                                                class="glyphicon glyphicon-pencil btn btn-default"
                                                @click="showTagButtons = !showTagButtons"></span></div>
                                        <category :showButtons="showTagButtons" :viewMode="{}" :user-id="userId"
                                            :cat-node="tagCatNode" :show-create-node="showCreateTagCatNode"
                                            @catSelected="tagCatsSelected" :selected="postTagCats" cat-type="tag"
                                            :expandAll="true" @onChanges="onTagCategoryChanges">
                                        </category>
                                    </div>
                                    <hr />


                                </div>

                                <div v-if="inView === 'categoryLabels'">
                                    <div>
                                        <!-- <h3 class="label-warning">{{ lang.postEditor.categoryLabels }}</h3> -->
                                        <category-labels :user-id="userId" :post-id="editPostId" v-on:onError="(err) => {
                                            showAlerts = true; errMsgs = err.msgs;
                                        }"></category-labels>
                                    </div>
                                </div>

                                <div v-if="inView === 'links'">

                                    <div v-if="cpdIsManagers">
                                        <div style="padding:8px 0px;">
                                            <!-- Nav tabs -->
                                            <ul class="nav nav-tabs">
                                                <li role="presentation" style="cursor:pointer;"
                                                    @click="changeView2('links')"
                                                    :class="{ active: inView2 === 'links' }">
                                                    <a @click.prevent>{{ lang.postEditor.links }}/{{ lang.postEditor.video }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="col-xs-12-hide" v-if="inView2 === 'links'"
                                        style="width:100%;margin:0 auto;overflow-y:scroll;overflow-x:hidden;">
                                        <!-- <div @click="loadPostLinks"><span class="btn btn-default"><span
                                                    class="glyphicon glyphicon-arrow-down"></span>
                                                {{ lang.postEditor.loadLinks }} </span></div> -->

                                        <div v-if="showPostLinks">
                                            <div style="background:gray;color:white;">
                                                <post-link :show-update="false" :show-remove="false" :show-create="true"
                                                    @createclicked="createPostLink"></post-link>
                                            </div>
                                            <div style="width:100%;position:relative;z-index:1;">
                                                <agx-linklist :links="postlinks" v-on:removeclicked="onPostLinkRemove"
                                                    v-on:updateclicked="onPostLinkUpdate"
                                                    v-on:setimgclicked="setPostLinkImg"></agx-linklist>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--add child posts-->
            <div class="row" v-if="isRootPost && inView === 'images'">
                <div class="col-xs-12" style="margin-top: 20px;">
                    <div class="form-control btn btn-default" style="text-align: center;"
                        @click="showChildPosts = !showChildPosts">
                        <span :class="{ 'glyphicon-plus': !showChildPosts, 'glyphicon-minus': showChildPosts }"
                            class="glyphicon" style="float: left;"></span>
                        <span>{{ lang.postEditor.childPosts }}</span>
                    </div>
                    <div v-if="showChildPosts" style="width:100%;margin:0 auto;overflow-y:scroll;overflow-x:hidden;">
                        <post-list v-if="showChildPosts" view-mode="postRow" :user-id="userId"
                            :initFilter="{ prid: editPostId }" @onselect="onPostSelect"></post-list>
                    </div>
                </div>
            </div>
            <!--end add child posts-->

        </div>
    </div>
</template>
<script>
import loading from '../components/base/Loading.vue';
import postList from './postList.vue';
import postLink from './postLink';
import postProps from './postProps.vue';
import MediaList from '../posts/components/AgxMediaList.vue';
import LinkList from '../posts/components/AgxLinkList.vue';
import ImageList from '../dashboards/imageList.vue';
import modalX from '../components/base/ModalX1.vue';
import category from './category.vue';
import categoryLabels from './categoryLabels.vue';
import apis from '../api/extApi.js';
import postPrice from './postPrice.vue';

export default {
    name: "postEditor",
    components: {
        postPrice: postPrice,
        categoryLabels: categoryLabels,
        category: category,
        postList: postList,
        ImageList: ImageList,
        postLink: postLink,
        postProps: postProps,
        AgxMedialist: MediaList,
        AgxLinklist: LinkList,
        modalX: modalX,
        loading: loading
    },
    filters: {
        CatName: function (cat) {
            if (cat) {
                return cat.name;
            }
            return "Please Select";
        },
        stringify: function (item) {
            return JSON.stringify(item);
        }
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        isRootPost: function () {
            return this.parentPostId === null;
        },
        cpdEditing: function () {
            return {
                props: this.editing.props === true,
                postbase: this.editing.postbase !== null
            };
        },
        cpdIsRoot: function () {
            return !this.isChild;
        },
        cpdPostbase: function () {
            return this.cpdGet("postbase");
        },
        catBtnLabel: function () {
            var ret = "Select Category";
            var pb = this.cpdGet("postbase");

            if (pb !== null) {
                var cat = pb.category;
                if (typeof (cat) !== "undefined" && cat !== null) {
                    var parentName = pb.parentCategory !== null ? pb.parentCategory.name : "";
                    ret = parentName + "/" + cat.name;
                }
            }
            return ret;
        },
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        },
        cpdIsManagers: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAdmin === true || dp.isManager === true);
        },
        cpdThumb: function () {
            var img = (this.images !== null && this.images.length > 0) ? this.images[0] : null;
            if (img !== null) { return img.thumbPath; }
            return null;
        },
        cpdCatEditable: function () {
            return this.dashProfile && (!this.dashProfile.hasTeam || this.dashProfile.isAdmin);
        }
    },
    props: {
        "editPostId": { type: String, default: null },
        "userId": { type: String, default: null },
        "parentPostId": { type: String, default: null }
    },
    data: function () {
        return {
            apiClient: null,
            catCodes: apis.api.settings.catCodes,
            showCategory: false,
            catNode: null,
            showCreateCatNode: false,
            tagCatNode: null,
            showCreateTagCatNode: false,
            postTagCats: { catIds: [], timestamp: 1 },
            showPostLinks: false,
            postbase: {},
            stateCode: null,
            postId: null,
            isChild: false,
            images: [],
            postlinks: [],
            title: null,
            textMsg: null,
            category: null,
            props: [],
            editing: {
                postbase: null,
                props: null,
                postlink: { linkUrl: null, linkText: null, linkTitle: null, postId: null }
            },
            isSelectingImage: false,
            isProcessingImage: false,
            imgHanlder: null,
            inView: 'postbase',
            inView2: '',
            isEditingPost: false,
            editingPostId: null,
            isLoading: false,
            showChildPosts: false,
            showCategoryButtons: false,
            showTagButtons: false,
            showAlerts: false,
            errMsgs: []
        }
    },
    mounted: function () {
        var postClientParam = {
            postId: this.editPostId,
            userId: this.userId,
            isAdmin: this.cpdIsManagers,
            showBtns: false //this.cpdIsManagers 
        };
        console.log('editPostId is:', postClientParam);
        this.apiClient = apis.ui.getPostClient(postClientParam);
        this.loadItem();
    },
    methods: {
        onShare: function () {
            let item = this.postbase;
            this.mxnPromptShare({ url: item.itemPath });
        },
        onCategoryChanges(val) {
            console.log('on category changes', val);
            this.loadCategory();
        },
        onTagCategoryChanges(val) {
            console.log('on tag category changes', val);
            this.loadTagCatNode();
        },
        onPaste(event) {
            event.preventDefault();
            let clb = (event.clipboardData || window.clipboardData);
            var items = clb.items;
            var images = [];
            if (items && items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var isImage = item.type.startsWith("image/");
                    if (isImage) {
                        images.push(item);
                    }
                }
            }
            var files = [];
            if (images.length > 0) {
                images.forEach(img => {
                    files.push(img.getAsFile());
                });
            }
            this.doFileUpload(files);
        },
        onFileDrop(event) {
            event.stopPropagation();
            event.preventDefault();
            console.log("file drop event", event);
            let files = event.dataTransfer.files;
            this.doFileUpload(files);
        },
        doFileUpload(files) {
            if (!files) return;
            var fileList = [...files];
            var data = new FormData();
            fileList.forEach(f => {
                console.log('the file is', f);
                data.append('file', f, f.name);
            });
            this.apiClient.uploadFilePrms(this.userId, data).done((ret) => {
                console.log('upload?FilePrms return', ret);
                if (ret.ok) {
                    var retFiles = ret.value;
                    retFiles.forEach((rFile) => {
                        this.onPostImgSelect(rFile);
                    });
                }
            });
        },
        changeView: function (newView) {
            this.inView = newView;
            if (this.inView === 'links') {
                this.changeView2('links');
                //this.loadPostLinks();
            }
        },
        changeView2: function (newView) {
            this.inView2 = newView;
            if (this.inView2 === 'links') {
                this.loadPostLinks();
            }
        },
        showImgSelector: function (handler) {
            this.isSelectingImage = true;
            this.imgHandler = handler;
        },
        onImgSelect: function (imgFile) {
            this.imgHandler(imgFile);
        },
        onPostImgSelect: function (ret) {
            this.isProcessingImage = true;
            this.apiClient.addFileToPostPrms({ postId: this.postId, fileName: ret.fileName })
                .done((addRet) => {
                    this.isProcessingImage = false;
                    this.images.push({ ...ret, postFileId: addRet.value, postId: this.postId });
                });
        },
        showPost: function (postId) {
            this.editingPostId = postId;
            this.isEditingPost = true;
        },
        onPostSelect: function (post) {
            this.showPost(post.postId);
        },
        onCatChange: function (catPair) {
            //var catPair = {parent:parentNode,child:catNode};
            console.log('selected catPair', catPair);
            var hasChilds = catPair.child && catPair.child.childs && catPair.child.childs.length > 0;
            if (hasChilds) return;//do not allow select parent node
            this.showCategory = false;
            this.changePostbase("category", catPair.child);
            this.changePostbase("parentCategory", catPair.parent);
        },
        loadItem: function () {
            this.postId = this.apiClient.postId;
            this.apiClient.loadingOverlay.show();
            this.apiClient.getPostByIdPrms(this.postId).done((post) => {
                if (post) {
                    this.postbase = post;
                    this.postId = post.postId;
                    this.title = post.title;
                    this.textMsg = post.textMsg;
                    this.category = post.category;
                    this.images = post.images;
                    this.stateCode = post.stateCode;
                    this.isChild = post.parentId !== null;
                    this.apiClient.loadingOverlay.hide();
                }
            }).fail(() => {
                console.log('failed load post');
                this.apiClient.loadingOverlay.hide();
            });
        },
        setPostLinkImg: function (link) {
            this.isSelectingImage = true;
            this.imgHandler = (img) => {
                var updateVal = { id: link.id, linkImg: img.fileName + img.fileType };
                this.apiClient
                    .updatePostLinkImgPrms(updateVal)
                    .done((ret) => {
                        link.imgThumb = img.thumbPath;
                        link.linkImg = updateVal.linkImg;
                    });
            };
        },
        createPostLink: function (newLink) {
            var thisInst = this;
            var item = newLink; //this.editing.postlink;
            item.postId = this.postId;
            this.apiClient.loadingOverlay.show();
            this.apiClient.addPostLinkPrms(item)
                .done((ret) => {
                    this.apiClient.loadingOverlay.hide();
                    if (ret.ok === true) {
                        thisInst.postlinks.unshift(ret.value);
                    }
                });
        },
        onPostLinkUpdate: function (link) {
            this.apiClient.loadingOverlay.show();
            this.apiClient.updatePostLinkPrms(link).done(() => {
                this.apiClient.loadingOverlay.hide();
            });
        },
        onPostLinkRemove: function (link) {
            this.apiClient.loadingOverlay.show();
            this.apiClient.removePostLinkPrms(link).done((ret) => {
                this.apiClient.loadingOverlay.hide();
                if (ret.ok === true) {
                    var index = this.postlinks.indexOf(link);
                    this.postlinks.splice(index, 1);
                }
            });
        },
        loadPostLinks: function () {
            var thisInst = this;
            this.apiClient.loadingOverlay.show();
            this.apiClient.getPostLinksPrms(this.postId).done((ret) => {
                this.apiClient.loadingOverlay.hide();
                thisInst.postlinks = ret;
            });
            this.showPostLinks = true;
        },
        onImageUpdate: function (data) {
            var thisInst = this;
            this.apiClient.updatePostFilePrms(data).done(function (ret) {
                thisInst.images = ret.value;
            });
        },
        onImageRemove: function (data) {
            var thisInst = this;
            this.apiClient.removeFileFromPostPrms(data).done(function (ret) {
                thisInst.images = ret.value;
            });
        },
        onPriceChanges: function (e) {

        },
        cpdGet: function (name) {
            if (this.editing[name]) {
                return this.editing[name];
            }
            return this[name];
        },
        changePostbase: function (prop, val) {
            if (!this.editing.postbase) {
                this.editing.postbase = $.extend(true, {}, this.postbase);
            }
            this.editing.postbase[prop] = val;
        },
        cancelPostbaseEdit: function () {
            this.editing.postbase = null;
        },
        cancelPropsEdit: function () {
            this.editing.props = false;
        },
        updatePostClick: function () {
            var $this = this;
            var postData = $this.editing.postbase;
            if (postData === null) {
                this.apiClient.alertOlay.show("No Change Detected!");
                return;
            }
            if (postData.category) {
                postData.catId = postData.category.catId;
            }
            this.apiClient.loadingOverlay.show();

            this.apiClient.updatePostBasePrms(postData).done((e) => {
                this.apiClient.loadingOverlay.hide();
                if (e.ok !== true) {
                    //this.apiClient.alertOlay.show("Update Failed!");
                    this.showAlerts = true;
                    this.errMsgs = e.msgs;
                    return;
                }
                $this.postbase = e.value;
                $this.editing.postbase = null;
            });
        },
        setPropertiesClick: function () {
            this.apiClient.setProperties();
        },
        showMainCatsClick: function () {
            this.showCategory = true;
            //this.apiClient.showMainCats();
            this.loadCategory();
        },
        loadCategory() {
            this.apiClient.getCategoryNodePrms(this.catCodes.listing, this.userId).done((catNode) => {
                console.log('catNode is', catNode);
                this.catNode = catNode;
                this.showCreateCatNode = catNode === null;
            });
        },
        showTagsLabels() {
            this.changeView('tagsLabels');
            this.loadPostTags();

            this.$nextTick(() => {
                this.loadTagCatNode();
            });
        },
        loadTagCatNode() {
            this.apiClient.getCategoryNodePrms(this.catCodes.tag, this.userId).done((catNode) => {
                console.log('tag catNode is', catNode);
                this.tagCatNode = catNode;
                this.showCreateTagCatNode = catNode === null;
            });
        },
        loadPostTags() {
            this.apiClient.getPostCatsPrms(this.editPostId).done((ret) => {
                console.log('postTagCats', ret);
                if (ret && ret.length >= 0) {
                    this.postTagCats.catIds = ret.map(t => t.child.catId);
                    this.postTagCats.timestamp = Date.now();
                }
                console.log('mapped postTagCats', this.postTagCats);
            });
        },
        tagCatsSelected(cat) {
            var catPair = cat;
            var hasChilds = catPair.child && catPair.child.childs && catPair.child.childs.length > 0;
            if (hasChilds) return;//do not allow select parent node

            var catId = cat.child.catId;
            if (this.postTagCats.catIds.indexOf(catId) >= 0) {
                this.apiClient.removePostCatPrms({ catId: catId, postId: this.editPostId }).done((ret) => {
                    console.log("removePostCatPrms return", ret);
                    if (ret.ok === false) {
                        this.errMsgs = ret.msgs;
                        this.showAlerts = true;
                    }
                    this.loadPostTags();
                });
            } else {
                this.apiClient.addPostCatPrms({ postId: this.editPostId, catId: catId }).done((ret) => {
                    console.log("addPostCatPrms return", ret);
                    this.loadPostTags();
                });
            }
        }
    },
    created: function () {

    },
    destroyed: function () {
        this.apiClient.destroy();
    }
}

</script>